


















import {defineComponent, PropType} from "vue";
import {ListIcon} from "./models/ListIcon";

export default defineComponent({
    name: "ListIcon",
    props: {
        elementType: {
            type: String,
            validator: (value: string) => ['ul', 'ol'].includes(value),
            default: 'ul'
        },
        items: {
            type: Array as PropType<ListIcon[]>,
            required: true
        },
        highlight: {
            type: Boolean,
            default: false
        },
        noBorderBottom: {
            type: Boolean,
            default: false
        }
    }
})

